module.exports = __webpack_public_path__ + "static/media/90s.e9b83c7b.png";